/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const FishingHook = [
  ["path", { d: "m17.586 11.414-5.93 5.93a1 1 0 0 1-8-8l3.137-3.137a.707.707 0 0 1 1.207.5V10" }],
  ["path", { d: "M20.414 8.586 22 7" }],
  ["circle", { cx: "19", cy: "10", r: "2" }]
];

export { FishingHook as default };
//# sourceMappingURL=fishing-hook.js.map
